import React, { useEffect } from 'react';

const AgeVerificationCallback = () => {
  useEffect(() => {
    const handleCallback = () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      const state = params.get('state');
      const error = params.get('error');
      const errorDescription = params.get('error_description');

      if (error) {
        console.error('ID.me verification error:', errorDescription);
        window.opener?.postMessage({ error, errorDescription }, window.location.origin);
      } else if (code && state) {
        window.opener?.postMessage({ code, state }, window.location.origin);
      }

      window.close();
    };

    handleCallback();
  }, []);

  return (
    <div className="callback-container">
      <h2>Verification in Progress</h2>
      <p>Please wait while we verify your identity...</p>
    </div>
  );
};

export default AgeVerificationCallback; 